import { clearPersistStoreKeys } from './commonUtils'
import { SHARED_PERSISTENT_STORE_KEYS } from '../constants/constants'

export const clearStorageDataOnLogout = () => {
  clearPersistStoreKeys([
    SHARED_PERSISTENT_STORE_KEYS.HAS_USED_UNIVERSAL_SEARCH,
    SHARED_PERSISTENT_STORE_KEYS.SHOW_PROVIDER_RESULTS_SURVEY_KEY,
  ])
}
